/** Presentation only: a shared linear scale with headroom for always-visible labels. */
export function reviewTimingChartScale(values: readonly number[]) {
  const maximumMs = Math.max(0, ...values.filter((value) => Number.isFinite(value) && value >= 0));
  const unitMs = maximumMs >= 120_000 ? 60_000 : 1_000;
  const ceilingMs = Math.max(unitMs, maximumMs * 1.2);
  const roughStep = ceilingMs / unitMs / 3;
  const magnitude = 10 ** Math.floor(Math.log10(roughStep));
  const multiple = [1, 2, 3, 5, 10].find((value) => value * magnitude >= roughStep) ?? 10;
  const stepMs = multiple * magnitude * unitMs;
  const ticks = Array.from({ length: Math.floor(ceilingMs / stepMs) + 1 }, (_, index) => {
    const valueMs = index * stepMs;
    return {
      valueMs,
      percent: (valueMs / ceilingMs) * 100,
      label: `${Number((valueMs / unitMs).toFixed(3))}${unitMs === 60_000 ? '分' : '秒'}`,
    };
  });
  return { ceilingMs, ticks };
}
